















































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import Arrow from '@/components/icons/ArrowLink.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import CalendarIcon from '@/components/icons/Calendar.vue';
import SuccessIcon from '@/components/icons/SuccessSolid.vue';
import ShareCampaign from '@/components/ShareCampaign/ShareCampaign.vue';
import PercentageCircle from '@/components/icons/PercentageCircle.vue';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import SocialMediaIcon from '@/components/icons/SocialMedia.vue';
import Radio from '@/components/molecules/Radio/Radio.vue';
import { EAutomaticCampaignName } from '@/models/sell-coins';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    Arrow,
    FilledButton,
    SuccessIcon,
    ShareCampaign,
    CalendarIcon,
    CoinsIcon,
    GhostButton,
    PercentageCircle,
    SocialMediaIcon,
    Radio
  }
})
export default class CampaignStatusManagement extends Vue {
  @Prop({ default: 'campaignAlreadyActive' }) readonly campaignType?: string;
  @Prop({ default: 'warning.svg' }) readonly iconName?: string;

  @Prop() activeCampaignData!: any;
  @Prop() newCampaignData!: any;
  @Prop() onConfirm!: (optionSelected?: string) => Promise<void>;
  optionSelected: string = 'disableSellCoins';
  campaignName: any = EAutomaticCampaignName;

  iconAltMap = new Map<string, string>([
    ['warning.svg', 'Warning'],
    ['success.svg', 'Success'],
    ['error.svg', 'error.png']
  ]);

  loading = false;

  handleClose() {
    eventBus.$emit('closeModal');
  }

  async handleConfirm() {
    this.loading = true;
    await this.onConfirm(this.optionSelected);
    this.loading = false;
    this.handleClose();
  }

  mounted() {
    window.addEventListener('popstate', () => {
      this.handleClose();
    });
  }

  created() {
    segmentIo.modal('Sell Coins Campaign Change Status', {
      'Status Type': this.campaignType
    });
  }

  get iconAlt() {
    return this.iconAltMap.get(this.iconName || '');
  }

  get tPrefix() {
    return 'sellCoins.modals';
  }

  get gaTracking() {
    return {
      eventCategory: 'Sell Coins Campaign | Share campaign (modal)',
      eventAction: 'click'
    };
  }

  get title() {
    return `${this.$t(`${this.tPrefix}.` + this.campaignType + `.title`)}`;
  }

  get description() {
    return `${this.$t(`${this.tPrefix}.` + this.campaignType + `.description`, {
      name: this.newCampaignData ? this.newCampaignData.name : ''
    })}`;
  }

  get btnConfirmationText() {
    return `${this.$t(
      `${this.tPrefix}.` + this.campaignType + `.confirmButton`
    )}`;
  }

  get btnSecondaryText() {
    return `${this.$t(
      `${this.tPrefix}.` + this.campaignType + `.secondaryButton`
    )}`;
  }
}
